import React, { useEffect, useState } from 'react'
import { Container, Row, Col, Card } from 'react-bootstrap'
import { useTranslation } from "react-i18next"
import useAuth from '../../context/auth/useAuth'
import { useDispatch, useSelector } from 'react-redux'
// import Swal from 'sweetalert2'
import { getCandidate } from '../../actions/candidatesActions'
import { OnBoardingCandidateProcess, OnBoardingCandidateProfile } from '../../components/helps/OnBoardingCandidate'
// import { Link } from 'react-router-dom'
import { addPrecandidate, getReducedAvailableSelectionsByCandidate } from '../../actions/selectionsActions'
import { getLevels } from '../../actions/miscellaneousActions'
// import JobSummary from '../../components/jobPortal/JobSummary'
// import JobDetails from '../../components/jobPortal/JobDetails'

export default function Dashboard() {
    const { t } = useTranslation()
    const dispatch = useDispatch()
	const {client} = useAuth()
    const {candidate, candidateuser, candidateStatus} = useSelector(state=>state.candidates)
    // const {loading, selections, resultselection} = useSelector(state => state.selections)
    // const {levels, subjects} = useSelector(state => state.miscellaneous)

    // const [selectedSelection, setSelectedSelection] = useState(null)

    // const handleSignUp = () => {
    //     Swal.fire({
    //         showConfirmButton: true,
    //         showDenyButton: true,
    //         confirmButtonText: t('global.accept'),
    //         denyButtonText: t('global.cancel'),
    //         icon: 'question',
    //         text: t('jobOffers.signUpQuestion')
    //     }).then((resultuser) => {
    //         if (resultuser.isConfirmed) {
    //             dispatch(addPrecandidate(selectedSelection?._id, candidate?._id))
    //         }
    //     })
    // }
    
    useEffect(() => {
        window.scrollTo({
            top: 0,
            behavior: 'instant',
        })
        if(client){
            dispatch(getCandidate(client?.id))
            dispatch(getReducedAvailableSelectionsByCandidate(client?.id))
            dispatch(getLevels())
        }
    },[dispatch, t, client])

    // useEffect(() => {
    //     if (resultselection) {
    //         setSelectedSelection(null)
    //         Swal.fire({
    //             showConfirmButton: true,
    //             showDenyButton: false,
    //             confirmButtonText: t('global.great'),
    //             icon: 'success',
    //             text: t('jobOffers.' + resultselection)
    //         })
    //         dispatch({
    //             type: 'SELECTION_RESET_RESULT'
    //         })
    //     }
    // }, [resultselection, dispatch])

    return (
        <>
            <Container className='cuerpo'>
                <Row>
                    <Col xs={12} md={8}>
                        <Card className='mb-5 sombra'>
                            <Card.Body className='px-5 py-5'>
                                <Row>
                                    <Col>
                                        {
                                            candidate?.sex === 'F'
                                                ?
                                                    <h1>{t('dashboard.candidate.welcomeFemale')} {client?.firstname}</h1>
                                                :
                                                    <h1>{t('dashboard.candidate.welcomeMale')} {client?.firstname}</h1>
                                        }
                                        <div className='mt-2 mb-3' dangerouslySetInnerHTML={{__html: t('dashboard.candidate.paragraph1')}}></div>
                                        <div dangerouslySetInnerHTML={{__html: t('dashboard.candidate.paragraph2')}}></div>
                                    </Col>
                                </Row>
                                <Row className='mt-4'>
                                    <Col className='onboarding'>
                                        <h3 className='mb-4'>{t('dashboard.onboardingCandidate.howCompleteProfile')}</h3>
                                        <OnBoardingCandidateProfile />
                                    </Col>
                                </Row>
                            </Card.Body>
                        </Card>
                        <Card className='mb-5 sombra'>
                            <Card.Body className='px-5 py-5'>
                                <Row>
                                    <Col>
                                        <h2>{t('dashboard.onboardingCandidate.titleProcess')}</h2>
                                        <div className='mt-2 mb-3' dangerouslySetInnerHTML={{__html: t('dashboard.onboardingCandidate.paragraph1')}}></div>
                                        <div dangerouslySetInnerHTML={{__html: t('dashboard.onboardingCandidate.paragraph2')}}></div>
                                    </Col>
                                </Row>
                                <Row className='my-5'>
                                    <Col className='onboarding'>
                                        <h3 className='mb-4'>{t('dashboard.onboardingCandidate.howCompleteProfile')}</h3>
                                        <OnBoardingCandidateProcess />
                                    </Col>
                                </Row>
                                <Row className='mt-4 mb-3'>
                                    <Col>
                                        <h2 className='mb-4'>{t('dashboard.onboardingCandidate.recommendation')}</h2>
                                        <div dangerouslySetInnerHTML={{__html: t('dashboard.onboardingCandidate.paragraph3')}}></div>
                                    </Col>
                                </Row>
                            </Card.Body>
                        </Card>
                    </Col>
                    {/* <Col xs={12} md={4}>
                        <Card className='mb-5 sombra'>
                            <Card.Body className='px-1 px-md-2 py-5'>
                                <Row>
                                    <Col>
                                        <h1 className='text-center'>{t('jobOffers.jobPortal')}</h1>

                                        {
                                            loading
                                            ?
                                                <div className='text-center mt-5'>
                                                    <span className="spinner-border spinner-border-sm align-middle ms-2"></span>
                                                </div>
                                            :
                                                selections?.length > 0
                                                ?
                                                    selections.map((selection, index) => (
                                                        <JobSummary key={index} selection={selection} onSelectSelecion={setSelectedSelection} levels={levels} />
                                                    ))
                                                :
                                                    <div className='text-center mt-5'>
                                                        <small>{t('jobOffers.noJobOffers')}</small>
                                                    </div>
                                        }
                                        <div className='d-flex justify-content-center mt-5'>
                                            <Link to="/candidate/job-portal" className='btn btn-primary'>{t('jobOffers.goTojobPortal')}</Link>
                                        </div>
                                    </Col>
                                </Row>
                            </Card.Body>
                        </Card>
                    </Col> */}
                </Row>
            </Container>
            {/* <JobDetails candidate={candidate} levels={levels} onSelectSelecion={setSelectedSelection} selection={selectedSelection}/> */}
        </>
    )
}